import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { PixelSettingsFormGroupType } from '@common/types/analytics-setings.type';
import { EPixelTypes } from '@common/types/analytics-setings.type';
import { type FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgFor, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'web-pixel-settings',
    templateUrl: './pixel-settings.component.html',
    styleUrls: ['./pixel-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ReactiveFormsModule, NgFor, NgIf, TranslateModule],
})
export class PixelSettingsComponent {
    @Input() public pixelSettings: PixelSettingsFormGroupType;
    @Input() public isAfterPayment: boolean;

    options = Object.values(EPixelTypes);

    public get type(): FormControl<EPixelTypes> {
        return this.pixelSettings.get('type') as FormControl<EPixelTypes>;
    }

    public get typeAfterPayment(): FormControl<EPixelTypes> {
        return this.pixelSettings.get('typeAfterPayment') as FormControl<EPixelTypes>;
    }

    protected readonly EPixelTypes = EPixelTypes;
}
